import React from 'react';
import { modalConstants } from '../../constants';
import { Wrapper, Overlay } from './styles';

export const Modal = ({ children, isActive, hideModal }) => {
  // const wrapperRef = useRef(null); // Ref to detect outside click
  // useOnClickOutside(wrapperRef, () => hideModal);

  return (
    <Wrapper isActive={isActive != modalConstants.HIDDEN}>
      <Overlay onClick={hideModal} />
      {children}
    </Wrapper>
  );
};
